import React from 'react';
import { Phone, MapPin, Mail, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/oldlogo.jpg"
                alt="Adhyan Study Spaces"
                className="h-12 w-12 object-contain rounded-lg"
              />
              <div>
                <h3 className="text-xl font-bold">Adhyan Study Spaces</h3>
                <p className="text-sm text-gray-400">Quiet Corners for Big Dreams</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium study environment designed for focused learning and achieving your goals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['home', 'advantages', 'facilities', 'gallery', 'plans', 'rules', 'location', 'contact'].map((section) => (
                <li key={section}>
                  <button
                    onClick={() => scrollToSection(section)}
                    className="text-gray-400 hover:text-blue-400 transition-colors text-sm capitalize"
                  >
                    {section === 'advantages' ? 'Why Us' : section}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm">
                <Phone size={18} className="text-blue-400 mt-0.5" />
                <a href="tel:7021465074" className="text-gray-400 hover:text-white transition-colors">
                  7021465074
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm">
                <MapPin size={18} className="text-blue-400 mt-0.5" />
                <span className="text-gray-400">
                  Shop 25 & 26, Aklavya CHS,<br />
                  Plot No 69 D/J/K, Sector 21,<br />
                  Kharghar, 410210
                </span>
              </li>
            </ul>
          </div>

          {/* Operating Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4">Operating Hours</h4>
            <div className="space-y-2 text-sm text-gray-400">
              <p className="flex justify-between">
                <span>All Days:</span>
                <span className="font-semibold text-blue-400">7 Day Access</span>
              </p>
              <div className="bg-teal-900/30 rounded-lg p-3 mt-4">
                <p className="text-blue-300 font-semibold">09AM-10PM</p>
                <p className="text-xs text-gray-400 mt-1">For all members</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Adhyan Study Spaces. All rights reserved.
            </p>
            {/* <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Twitter size={20} />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
